import script from "./TradePanel.vue?vue&type=script&setup=true&lang=js"
export * from "./TradePanel.vue?vue&type=script&setup=true&lang=js"

import "./TradePanel.vue?vue&type=style&index=0&id=52b10910&lang=less&scoped=true"

import exportComponent from "E:\\上蔡\\大数据\\宽版\\shancgai2-修改农业-审计修改\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-52b10910"]])

export default __exports__